import { get } from 'lodash-es';
import classNames from 'classnames';
import React, { useMemo } from "react";
import { useSelector } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import { CookiesProvider } from "react-cookie";
import { useTranslation } from 'react-i18next';
import logo from '../../../images/blue_logo.svg';
import CookiesPrompt from '../../../influencer/pages/home/CookiesPrompt';
import Divider from '../Divider';
import './Footer.scss';

const socialNetworks = [{
  link: 'https://www.tiktok.com/@obviouslysocial',
  icon: 'fa-tiktok',
}, {
  link: 'https://twitter.com/obviouslysocial',
  icon: 'fa-twitter',
}, {
  link: 'https://www.instagram.com/obviously/',
  icon: 'fa-instagram',
}, {
  link: 'https://www.facebook.com/obviouslysocial',
  icon: 'fa-facebook',
}, {
  link: 'https://www.pinterest.com.mx/ObviouslySocial/',
  icon: 'fa-pinterest',
}];

const agentLinks = [{
  title: 'common.footer.contact_us',
  link: '/clients/contact-us',
  external: false,
}];

const Footer = () => {
  const { t } = useTranslation();
  const isAgentsApp = !!location.pathname.match(/^\/clients/);
  const isPublicAgentPage = !!location.pathname.match(/^\/clients\/(signin|forgot-your-password|reset-your-password)/);
  const agent = useSelector(state => state.auth.agent);
  const simulatedAgent = useSelector(state => get(state, 'config.simulatedAgent'));


  const links = useMemo(() => [{
    title: 'common.footer.about_us',
    link: isAgentsApp
      ? 'https://www.obvious.ly/brands-and-agencies'
      : 'https://www.obvious.ly/influencers-and-creators',
    external: true,
  }, {
    title: 'common.footer.privacy_policy',
    link: isAgentsApp
      ? '/clients/privacy-policy'
      : '/influencers/privacy-policy',
  }, {
    title: 'common.footer.terms_conditions',
    link: isAgentsApp
      ? '/clients/terms-of-service'
      : '/influencers/terms-of-service',
    external: isAgentsApp
  }], [isAgentsApp]);

  if(isAgentsApp && !agent && !isPublicAgentPage)
    return null;

  return (
    <footer className="footer">
      <Divider />
      <Container className="mt-5 pb-5">
        <div className="logo mb-5">
          <img src={logo} alt="Obviously" className="logo" />
        </div>
        <div className="content">
          <Row className="justify-content-between">
            <Col xs={12} sm="auto">
              {
                links.map(link => (
                  <div key={link.title}>
                    <a className="btn link" href={link.link} target={link.external ? '_blank' : '_self'} rel="noreferrer" >
                      {t(link.title)}
                    </a>
                  </div>
                ))
              }
            </Col>
            {isAgentsApp &&
              <Col xs={12} sm="auto">
                {
                  agentLinks.map(link => (
                    <div key={link.title}>
                      <a className="btn link" href={link.link} target={link.external ? '_blank' : '_self'} rel="noreferrer" >
                        {t(link.title)}
                      </a>
                    </div>
                  ))
                }
              </Col>
            }
            <Col xs={12} sm="auto" >
              <Row className="social-networks justify-content-sm-end">
                <Col xs="auto">
                  {
                    socialNetworks.map(network => (
                      <a
                        key={network.link}
                        href={network.link}
                        className="social-network"
                        target="_blank" rel="noreferrer">
                        <i className={classNames("fab", network.icon)}></i>
                      </a>
                    ))
                  }
                </Col>

              </Row>
            </Col>
          </Row>
        </div>
        <div className="copyright">
          © {new Date().getFullYear()} Obviously - {t('common.footer.rights_reserved')}
        </div>
        <CookiesProvider>
          <CookiesPrompt />
        </CookiesProvider>
      </Container>
    </footer>
  );
};


export default React.memo(Footer);
